// extracted by mini-css-extract-plugin
export var smallSpinner = "_qu-0";